import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';
import PageWithCustomerSelector from '../PageWithCustomerSelector';
import DashboardWelcome from './DashboardWelcome';
import OperationalDashboardPanel from './OperationalDashboardPanel';
import { canAccessOperationalDashboard } from '../../constants/operationalMetricCatalog';

const DashboardContainer = styled.div`
    padding: clamp(16px, 3vw, 32px);
    min-width: 0;
`;

export default function Dashboard() {
    const { user } = useAuth();
    const canViewDashboard = canAccessOperationalDashboard(user?.roles);
    const [metricsState, setMetricsState] = useState({ loading: false, hasMetrics: false });
    const handleMetricsStateChange = useCallback((state) => {
        setMetricsState(state);
    }, []);

    const showQuickAccess = !canViewDashboard || (!metricsState.loading && !metricsState.hasMetrics);

    return (
        <DashboardContainer>
            <DashboardWelcome showQuickAccess={showQuickAccess} />
            {canViewDashboard ? (
                <PageWithCustomerSelector
                    selectorFirstOptionLabel="Todas as empresas"
                    selectorFirstOptionDescription="Visão consolidada de entregas e indicadores"
                    includePhysicalCustomers
                >
                    <OperationalDashboardPanel onMetricsStateChange={handleMetricsStateChange} />
                </PageWithCustomerSelector>
            ) : null}
        </DashboardContainer>
    );
}
